var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 3.4H2.86699M2.86699 3.4H12.467M2.86699 3.4V11.8C2.86699 12.1183 2.99342 12.4235 3.21846 12.6485C3.44351 12.8736 3.74873 13 4.06699 13H10.067C10.3853 13 10.6905 12.8736 10.9155 12.6485C11.1406 12.4235 11.267 12.1183 11.267 11.8V3.4H2.86699ZM4.66699 3.4V2.2C4.66699 1.88174 4.79342 1.57652 5.01846 1.35147C5.24351 1.12643 5.54873 1 5.86699 1H8.26699C8.58525 1 8.89048 1.12643 9.11552 1.35147C9.34056 1.57652 9.46699 1.88174 9.46699 2.2V3.4",
    stroke: "#FF4C51",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.c3125f172ac6c37b03aeb405e516b6eb.svg";
export { ForwardRef as ReactComponent };